import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";
import type { SelectOption } from "./types";

interface Props {
  modelValue?: string | number | boolean;
  options?: SelectOption[];
  disabled?: boolean;
  size?: SizeType;
  name?: string;
  /** default | button */
  optionType?: "default" | "button";
  buttonStyle?: "outline" | "solid";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Radio',
  props: {
    modelValue: { type: [String, Number, Boolean], default: undefined },
    options: { default: () => [] },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    name: { default: undefined },
    optionType: { default: "default" },
    buttonStyle: { default: "outline" }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const normalizedOptions = computed(() => props.options || []);

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: string | number | boolean) => {
    emit("update:modelValue", val);
  },
});

const onChange = (e: any) => {
  const val = e?.target?.value ?? e;
  emit("update:modelValue", val);
  // Giữ event gốc để tương thích handler kiểu e.target.value
  emit("change", e);
};

return (_ctx: any,_cache: any) => {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (_openBlock(), _createBlock(_component_a_radio_group, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    disabled: _ctx.disabled,
    "option-type": _ctx.optionType,
    "button-style": _ctx.buttonStyle,
    size: _ctx.size,
    name: _ctx.name,
    class: "ant-radio-group-wrap",
    onChange: onChange
  }, {
    default: _withCtx(() => [
      (normalizedOptions.value.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(normalizedOptions.value, (opt) => {
            return (_openBlock(), _createBlock(_component_a_radio, {
              key: String(opt.value),
              value: opt.value,
              disabled: opt.disabled
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(opt.label), 1)
              ]),
              _: 2
            }, 1032, ["value", "disabled"]))
          }), 128))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["value", "disabled", "option-type", "button-style", "size", "name"]))
}
}

})